module.exports = __webpack_public_path__ + "static/adoption-section-background-205dadcd9d72f34993e386af8ccc6729.jpg";